export default {"src":"/_next/static/media/RedFlag.ccdd2df1.svg","height":12,"width":11};